import { render, staticRenderFns } from "./Cn-SDS-Liquid.vue?vue&type=template&id=c75be1ec&scoped=true&"
import script from "./Cn-SDS-Liquid.vue?vue&type=script&lang=js&"
export * from "./Cn-SDS-Liquid.vue?vue&type=script&lang=js&"
import style0 from "./Cn-SDS-Liquid.vue?vue&type=style&index=0&id=c75be1ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c75be1ec",
  null
  
)

export default component.exports